
  import { defineComponent, PropType } from 'vue';

  import RedesignedSwitchComponent from '@/common/components/redesigned/RedesignedSwitchComponent.vue';

  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import AnalyticsNotesProductsExportTable from './AnalyticsNotesProductsExportTable.vue';
  import AnalyticsNotesProductsImportTable from './AnalyticsNotesProductsImportTable.vue';
  import AnalyticsNotesStructureExportTable from './AnalyticsNotesStructureExportTable.vue';
  import AnalyticsNotesStructureImportTable from './AnalyticsNotesStructureImportTable.vue';

  export default defineComponent({
    name: 'AnalyticsNotesTradeTabSwitcher',
    components: {
      RedesignedSwitchComponent,
      AnalyticsNotesStructureExportTable,
      AnalyticsNotesStructureImportTable,
      AnalyticsNotesProductsExportTable,
      AnalyticsNotesProductsImportTable,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    data(): { isExport: boolean } {
      return {
        isExport: true,
      };
    },
    methods: {
      switchHandler(isExport: boolean) {
        this.isExport = isExport;
      },
    },
  });
